export const API_ENDPOINT = 'event';


// WEBPACK FOOTER //
// ./src/state/modules/event/configurations/endpoints.js